<article class="feed-card-container">

    <div class="flex w-full min-w-0 flex-row items-start justify-between gap-3">

        <div class="flex min-w-0 flex-1 items-center">

            <div class="shrink-0">
                <img [src]="imageService.getImageSource(activity.briefApplications[0]?.creator?.photoURL, 'gallery')"
                    alt=""
                    class="size-12 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10" />
            </div>

            <div class="ml-3 min-w-0 flex-1">
                <div class="flex min-w-0 flex-row items-center gap-x-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4 text-fuchsia-700">
                        <path d="M12 3v12" />
                        <path d="m17 8-5-5-5 5" />
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    </svg>
                    <h3 class="truncate text-base font-semibold text-primary">
                        {{ activity.briefApplications[0]?.creator?.firstName }} {{
                        activity.briefApplications[0]?.creator?.lastName }}</h3>
                </div>
                <p class="text-sm text-secondary">
                    Has uploaded a draft!
                </p>
            </div>
        </div>

        <div class="flex shrink-0 flex-col items-start justify-start h-full">

            <p class="text-sm text-secondary">
                {{ headerTimeSince() }}
            </p>
        </div>
    </div>


    <div class="w-full overflow-hidden">
        <div class="flex flex-row gap-x-3 overflow-x-auto scrollbar-transparent pb-2">
            @for (application of activity.briefApplications; track application.id) {
            @for (video of application.applicationVideos; track video.id) {
            <div
                class="flex-none w-3/5 md:w-1/2 lg:w-2/5 flex flex-row items-start justify-start gap-x-2 p-2 border border-[var(--input)] rounded-lg">
                <!-- thumbnail -->
                <div (click)="viewContent(video, application)"
                    class="relative w-1/4 overflow-hidden hover:cursor-pointer">

                    @switch (video.status) {
                    <!-- New Video -->
                    @case (0) {
                    <span
                        class="z-20 absolute top-0 right-0 mt-1 mr-1 inline-flex items-center gap-x-1.5 rounded-md bg-sky-100 px-1.5 py-0.5 text-xs font-medium text-sky-600">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-sky-500">
                            <path d="M10.268 21a2 2 0 0 0 3.464 0" />
                            <path d="M15 8h6" />
                            <path d="M18 5v6" />
                            <path
                                d="M20.002 14.464a9 9 0 0 0 .738.863A1 1 0 0 1 20 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 8.75-5.332" />
                        </svg>
                        New
                    </span>
                    }
                    <!-- Seen Video -->
                    @case (1) {
                    <span
                        class="z-20 absolute top-0 right-0 mt-1 mr-1 inline-flex items-center gap-x-1.5 rounded-md bg-fuchsia-100 px-1.5 py-0.5 text-xs font-medium text-fuchsia-600">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-fuchsia-500">
                            <path
                                d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                            <circle cx="12" cy="12" r="3" />
                        </svg>
                        Seen
                    </span>
                    }
                    <!-- Approved Video -->
                    @case (2) {
                    <span
                        class="z-20 absolute top-0 right-0 mt-1 mr-1 inline-flex items-center gap-x-1.5 rounded-md bg-green-100 px-1.5 py-0.5 text-xs font-medium text-green-600">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-green-500">
                            <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                            <path d="m9 11 3 3L22 4" />
                        </svg>
                        Approved
                    </span>
                    }
                    <!-- Declined Video -->
                    @case (3) {
                    <span
                        class="z-20 absolute top-0 right-0 mt-1 mr-1 inline-flex items-center gap-x-1.5 rounded-md bg-orange-100 px-1.5 py-0.5 text-xs font-medium text-orange-600">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-orange-500">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M16 16s-1.5-2-4-2-4 2-4 2" />
                            <line x1="9" x2="9.01" y1="9" y2="9" />
                            <line x1="15" x2="15.01" y1="9" y2="9" />
                        </svg>
                        Declined
                    </span>
                    }
                    }

                    <atom-video-thumbnail [videoUrl]="video.fullUrl" [videoId]="video.id"
                        [thumbnailURL]="video.thumbnailURL ? video.thumbnailURL : undefined"
                        [cdnKey]="video.thumbnailCdnKey ? video.thumbnailCdnKey : undefined"
                        [videoFormat]="0"></atom-video-thumbnail>
                </div>
                <div class="flex-1 h-full flex flex-col justify-between">
                    <div class="shrink-0 w-full flex flex-col gap-y-2">
                        <!-- draft name -->
                        <h4 class="text-sm font-bold text-primary truncate">{{ video.videoName }}</h4>


                        @if (video.aiModerateScore && video.videoAiModerates) {
                        @switch(aiReviewSuggestion(video.videoAiModerates[0])) {
                        @case ('pass') {
                        <!-- AI Pass -->
                        <div
                            class="rounded-md bg-green-50 px-4 py-2 dark:bg-green-500/10 dark:outline dark:outline-green-500/20">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5 text-green-400">
                                        <path
                                            d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                                        <path d="M7 10v12" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm text-green-800 dark:text-green-300">AI Recommends: <span
                                            class="font-bold">Pass</span></p>
                                </div>
                                <div class="ml-auto pl-3">
                                    <p class="text-sm text-green-400">{{ video.videoAiModerates[0].score }}% Accurate
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- AI Pass END -->
                        }
                        @case ('review') {
                        <!-- AI Review Required -->
                        <div
                            class="rounded-md bg-yellow-50 px-4 py-2 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/20">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5 text-yellow-400">
                                        <path d="M12 3v18" />
                                        <path d="m19 8 3 8a5 5 0 0 1-6 0zV7" />
                                        <path d="M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1" />
                                        <path d="m5 8 3 8a5 5 0 0 1-6 0zV7" />
                                        <path d="M7 21h10" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm text-yellow-800 dark:text-yellow-300">AI Recommends: <span
                                            class="font-bold">Review Required</span></p>
                                </div>
                                <div class="ml-auto pl-3">
                                    <p class="text-sm text-yellow-400">{{ video.videoAiModerates[0].score }}% Accurate
                                    </p>
                                </div>
                            </div>
                        </div>

                        @if (hasSuggestedFix(video.videoAiModerates[0])) {
                        <div *hasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation]"
                            class="rounded-md bg-gray-50 p-2 dark:bg-gray-500/10 dark:outline dark:outline-gray-500/15">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5 text-yellow-400 dark:text-yellow-300">
                                        <path
                                            d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <h3 class="text-sm font-medium text-gray-800 dark:text-gray-100">Suggested Fixes
                                    </h3>
                                    <ul class="list-disc list-inside pt-2">
                                        @for (suggestedFix of suggestedFixes(video.videoAiModerates[0]).slice(0, 2);
                                        track
                                        $index) {
                                        <li class="text-xs text-secondary">{{ suggestedFix }}</li>
                                        }
                                        @if (suggestedFixes(video.videoAiModerates[0]).length > 3) {
                                        <li class="text-xs text-secondary">+{{
                                            suggestedFixes(video.videoAiModerates[0]).length - 2 }} more</li>
                                        }
                                    </ul>

                                </div>
                            </div>
                        </div>

                        <div *notHasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation]"
                            class="rounded-md bg-gray-50 p-2 dark:bg-gray-500/10 dark:outline dark:outline-gray-500/15">
                            <div class="flex flex-row gap-x-4">
                                <div class="shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5 text-gray-400">
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="M12 16v-4" />
                                        <path d="M12 8h.01" />
                                    </svg>
                                </div>
                                <div class="flex-1">
                                    <h3 class="text-sm font-medium text-gray-800 dark:text-gray-200">There are {{
                                        suggestedFixes(video.videoAiModerates[0]).length }} Sugested Fixes for this
                                        draft.
                                    </h3>
                                    <div class="mt-2 text-sm text-gray-700 dark:text-gray-200/80">
                                        <ul role="list" class="list-disc space-y-1 pl-5">
                                            <li>Add the <i class="italic">AI Moderation Bolt-On</i> to enable suggested
                                                fixes.
                                            </li>
                                            <li>For high-speed campaign management, we recommend upgrading your account.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="shrink-0 h-full flex flex-col items-end justify-end">
                                    <button (click)="openChoosePlan()" type="button"
                                        class="inline-flex items-center gap-x-1.5 rounded-sm flashy-go-button hover:cursor-pointer">
                                        Add Bolt-On
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M12 2a10 10 0 0 1 7.38 16.75" />
                                            <path d="m16 12-4-4-4 4" />
                                            <path d="M12 16V8" />
                                            <path d="M2.5 8.875a10 10 0 0 0-.5 3" />
                                            <path d="M2.83 16a10 10 0 0 0 2.43 3.4" />
                                            <path d="M4.636 5.235a10 10 0 0 1 .891-.857" />
                                            <path d="M8.644 21.42a10 10 0 0 0 7.631-.38" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        }
                        }




                        @case ('fail') {
                        <!-- AI Fail -->
                        <div
                            class="rounded-md bg-red-50 px-4 py-2 dark:bg-red-500/10 dark:outline dark:outline-red-500/20">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5 text-red-400">
                                        <path
                                            d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
                                        <path d="M17 14V2" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm text-red-800 dark:text-red-300">AI Recommends: <span
                                            class="font-bold">Fail</span></p>
                                </div>
                                <div class="ml-auto pl-3">
                                    <p class="text-sm text-red-400">{{ video.videoAiModerates[0].score }}% Accurate</p>
                                </div>
                            </div>
                        </div>

                        @if (hasSuggestedFix(video.videoAiModerates[0])) {
                        <div *hasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation]"
                            class="rounded-md bg-gray-50 p-2 dark:bg-gray-500/10 dark:outline dark:outline-gray-500/15">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5 text-yellow-400 dark:text-yellow-300">
                                        <path
                                            d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <h3 class="text-sm font-medium text-gray-800 dark:text-gray-100">Suggested Fixes
                                    </h3>
                                    <ul class="list-disc list-inside pt-2">
                                        @for (suggestedFix of suggestedFixes(video.videoAiModerates[0]).slice(0, 2);
                                        track
                                        $index) {
                                        <li class="text-xs text-secondary">{{ suggestedFix }}</li>
                                        }
                                        @if (suggestedFixes(video.videoAiModerates[0] ).length > 3) {
                                        <li class="text-xs text-secondary">+{{
                                            suggestedFixes(video.videoAiModerates[0]).length - 2 }} more</li>
                                        }
                                    </ul>

                                </div>
                            </div>
                        </div>

                        <div *notHasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation]"
                            class="rounded-md bg-gray-50 p-2 dark:bg-gray-500/10 dark:outline dark:outline-gray-500/15">
                            <div class="flex flex-row gap-x-4">
                                <div class="shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5 text-gray-400">
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="M12 16v-4" />
                                        <path d="M12 8h.01" />
                                    </svg>
                                </div>
                                <div class="flex-1">
                                    <h3 class="text-sm font-medium text-gray-800 dark:text-gray-200">There are {{
                                        suggestedFixes(video.videoAiModerates[0]).length }} Sugested Fixes for this
                                        draft.
                                    </h3>
                                    <div class="mt-2 text-sm text-gray-700 dark:text-gray-200/80">
                                        <ul role="list" class="list-disc space-y-1 pl-5">
                                            <li>Add the <i class="italic">AI Moderation Bolt-On</i> to enable suggested
                                                fixes.
                                            </li>
                                            <li>For high-speed campaign management, we recommend upgrading your account.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- <div class="shrink-0 h-full flex flex-col items-end justify-end">
                                    <button (click)="openChoosePlan()" type="button"
                                        class="inline-flex items-center gap-x-1.5 rounded-sm flashy-go-button hover:cursor-pointer">
                                        Add Bolt-On
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M12 2a10 10 0 0 1 7.38 16.75" />
                                            <path d="m16 12-4-4-4 4" />
                                            <path d="M12 16V8" />
                                            <path d="M2.5 8.875a10 10 0 0 0-.5 3" />
                                            <path d="M2.83 16a10 10 0 0 0 2.43 3.4" />
                                            <path d="M4.636 5.235a10 10 0 0 1 .891-.857" />
                                            <path d="M8.644 21.42a10 10 0 0 0 7.631-.38" />
                                        </svg>
                                    </button>
                                </div> -->
                            </div>

                            <div class="w-full flex flex-row items-center justify-end pt-2">
                                <button (click)="openChoosePlan()" type="button"
                                    class="inline-flex items-center gap-x-1.5 rounded-sm flashy-go-button hover:cursor-pointer">
                                    Add Bolt-On
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5">
                                        <path d="M12 2a10 10 0 0 1 7.38 16.75" />
                                        <path d="m16 12-4-4-4 4" />
                                        <path d="M12 16V8" />
                                        <path d="M2.5 8.875a10 10 0 0 0-.5 3" />
                                        <path d="M2.83 16a10 10 0 0 0 2.43 3.4" />
                                        <path d="M4.636 5.235a10 10 0 0 1 .891-.857" />
                                        <path d="M8.644 21.42a10 10 0 0 0 7.631-.38" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        }
                        }
                        }



                        } @else {
                        <!-- AI pending state (no AI data available for Started groups) -->
                        <div
                            class="rounded-md bg-gray-50 px-4 py-2 dark:bg-gray-500/10 dark:outline dark:outline-gray-500/20">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5 text-gray-400">
                                        <path d="M5 22h14" />
                                        <path d="M5 2h14" />
                                        <path
                                            d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22" />
                                        <path
                                            d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm text-gray-800 dark:text-gray-300">AI Moderation is in progress...
                                    </p>
                                </div>
                                <div class="ml-auto pl-3">
                                    <p class="text-sm text-gray-400">Pending</p>
                                </div>
                            </div>
                        </div>
                        }
                    </div>


                    <!-- actions -->
                    <div class="mt-3 w-full flex flex-row items-center justify-between">

                        <p class="text-sm text-gray-500 dark:text-gray-400">Uploaded:
                            {{ videoTimeSinceLabel(video) }}</p>

                        <button type="button" (click)="viewContent(video, application)"
                            class="inline-flex items-center gap-x-1.5 rounded-full bg-primary px-2.5 py-1.5 text-sm text-white shadow-xs hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:shadow-none dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                            View Content
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="-mr-0.5 size-5">
                                <path
                                    d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                            </svg>
                        </button>
                    </div>
                </div>

            </div>
            }
            }
        </div>
    </div>

    <div class="w-full flex flex-row items-center justify-end">

        <button (click)="goToApplication()" type="button"
            class="inline-flex items-center gap-x-1.5 rounded-full bg-fuchsia-600 px-2.5 py-1.5 text-sm text-white shadow-xs hover:bg-fuchsia-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fuchsia-600 dark:bg-fuchsia-500 dark:shadow-none dark:hover:bg-fuchsia-400 dark:focus-visible:outline-fuchsia-500">
            View Application
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="-mr-0.5 size-5">
                <path
                    d="M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z" />
                <path d="M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" />
            </svg>
        </button>
    </div>

</article>

@if (showVideoFeedback() && creator()) {
<vs-video-feedback (close)="closeVideoFeedback()" [video]="showVideoFeedback()"
    [videos]="selectedBriefApplication()?.applicationVideos ?? []" [creator]="creator()!"
    [isUgcOnly]="getIsUgcOnly()" [videoFormat]="showVideoFeedback()!.videoFormat"
    [briefApplication]="selectedBriefApplication()!" [defaultMessageText]="defaultMessageText()"
    (videoChange)="showVideoFeedback.set($event)">
</vs-video-feedback>
}